import { gql } from '__generated__';

export default gql(`
  mutation DeleteTicketCategory($id: ID!) {
    deleteTicketCategory(id: $id)
  }
`);
